import cloneDeep from 'lodash/cloneDeep'

class CustomExportFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)

        return entity
    }

    fromEntity(entity) {
        const formData = cloneDeep(entity)

        if (formData.category) {
            formData.category = formData.category['@id']
        }

        return formData
    }
}

export default new CustomExportFormMapper()
